module.exports = __webpack_public_path__ + "static/media/request_quote_white_24dp.cf87d168.svg";